import { render, staticRenderFns } from "./DropFirstVersionStageModal.vue?vue&type=template&id=fac7dbbc&scoped=true&"
import script from "./DropFirstVersionStageModal.vue?vue&type=script&lang=js&"
export * from "./DropFirstVersionStageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac7dbbc",
  null
  
)

export default component.exports